module.exports = __webpack_public_path__ + "static/7-d1d3397a4ba03a8da6446e4c982749f1.jpg";